import SrTag from "./index.vue";

SrTag.install = function(Vue) {
  Vue.component(SrTag.name, SrTag);
};

export default SrTag;



// WEBPACK FOOTER //
// ./packages/SrTag/index.js